import {makeAutoObservable} from "mobx";
import {MerchantPortalDto, MerchantPortalId} from "./merchant-portal-menu-list-store";

class MerchantPortalMenuItemStore {
    private _portal:MerchantPortalDto;
    private _secondaryPortals: MerchantPortalMenuItemStore[] = [];
    private _mainPortal?: MerchantPortalMenuItemStore;

    constructor(portal: MerchantPortalDto, mainPortal?: MerchantPortalMenuItemStore) {
        this._portal = portal;
        this._mainPortal = mainPortal;

        const secondaryPortals = Object.values(portal.portals ?? {});
        if (secondaryPortals.length > 0) {
            this._secondaryPortals = MerchantPortalMenuItemStore._initPortals(secondaryPortals, this);
        }

        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get id(): MerchantPortalId {
        return this._portal.id;
    }

    public get label(): MerchantPortalDto['label'] {
        return this._portal.label;
    }

    public get lowercaseLabel(): MerchantPortalDto['label'] {
        return this._portal.label.toLowerCase();
    }

    public get portals(): MerchantPortalMenuItemStore[] {
        return this._secondaryPortals;
    }

    public get mainPortal(): MerchantPortalMenuItemStore|undefined {
        return this._mainPortal;
    }

    public get isMain(): boolean {
        return !this.mainPortal;
    }

    public getPortalsByLabel(label: string): MerchantPortalMenuItemStore[] {
        if (!label) {
            return this._secondaryPortals;
        }

        return this._secondaryPortals.filter(portal => portal.lowercaseLabel.includes(label));
    }

    public static fromMerchantPortals(portals: MerchantPortalDto[]): MerchantPortalMenuItemStore[] {
        return MerchantPortalMenuItemStore._initPortals(portals);
    }

    private static _initPortals(portals: MerchantPortalDto[], mainPortal?: MerchantPortalMenuItemStore): MerchantPortalMenuItemStore[] {
        return portals.map(portal => new MerchantPortalMenuItemStore(portal, mainPortal));
    }
}

export default MerchantPortalMenuItemStore;